import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { ReplayIcon } from "@jti/brand-icons/replay";
import { Checkbox } from "../../../../../../components/Checkbox/Checkbox";
import { useDrawer } from "../../../../../../components/Drawer/providers";
import { useStoreLocatorContext } from "../../../../../../components/StoreLocator/hooks";
import { OPEN_NOW_CATEGORY, OPEN_NOW_FILTER_OBJ } from "../../../../../../components/StoreLocator/utils";
import { useTranslations } from "../../../../../../providers/useTranslations";
import { StoreLocatorFilterCategorySection } from "../StoreLocatorFilterCategory";
import stylesCategory from "../StoreLocatorFilterCategory/StoreLocatorFilterCategory.module.scss";
import styles from "./StoreLocatorFiltersModal.module.scss";
export const StoreLocatorFiltersAll = ({ changeFilters, checkFiltersStatus }) => {
    const bodyRef = useRef(null);
    const { __ } = useTranslations();
    const { selectedFiltersNumber, newFilters, handleResetFilters, isOpenNowFilterEnabled, isMultipleFiltersSectionOpenEnabled, defaultOpenedFilterCategory, } = useStoreLocatorContext();
    const [openCategories, setOpenCategories] = useState([]);
    const { closeDrawer } = useDrawer();
    useEffect(() => {
        bodyRef.current = document.body;
    }, []);
    useEffect(() => {
        if (newFilters?.[0]) {
            let categoryKey = newFilters[0]?.key;
            if (defaultOpenedFilterCategory) {
                categoryKey = newFilters.find((filter) => filter.key === defaultOpenedFilterCategory)?.key ?? categoryKey;
            }
            setOpenCategories([categoryKey]);
        }
    }, [newFilters, defaultOpenedFilterCategory]);
    const handleCategoryClick = (categoryKey) => {
        setOpenCategories((prevCategories) => {
            if (!isMultipleFiltersSectionOpenEnabled) {
                return [categoryKey];
            }
            if (prevCategories.some((category) => category === categoryKey)) {
                return prevCategories.filter((category) => category !== categoryKey);
            }
            return [...prevCategories, categoryKey];
        });
    };
    const handleCloseFilters = () => {
        closeDrawer();
        handleResetFilters();
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.filtersTitleContainer, children: [_jsx("h2", { className: styles.filtersTitle, "data-testid": "storeLocatorFiltersModalTitle", children: __("storelocator.filtersby") }), !!selectedFiltersNumber && (_jsxs("button", { className: styles.resetButton, onClick: handleCloseFilters, "data-testid": "storeLocatorResetFilters", "aria-label": __("storelocator.reset_filters"), children: [_jsx(ReplayIcon, { className: styles.resetButtonIcon, height: "20px", width: "20px", "aria-hidden": "true" }), __("storelocator.reset_filters")] }))] }), _jsxs("div", { className: styles.filtersList, children: [isOpenNowFilterEnabled && (_jsxs("div", { className: stylesCategory.filtersCategory, children: [_jsx("h3", { className: stylesCategory.filtersCategoryTitle, children: __("storelocator.filters.category.open_now") }), _jsx(Checkbox, { labelHtml: __("store_locator.popup.shop_status.open"), onChange: () => {
                                    changeFilters(OPEN_NOW_CATEGORY, OPEN_NOW_FILTER_OBJ);
                                }, value: { checked: checkFiltersStatus(OPEN_NOW_CATEGORY, OPEN_NOW_CATEGORY) } })] })), newFilters?.map((filterCategory) => (_jsx(StoreLocatorFilterCategorySection, { filterCategory: filterCategory, handleCategoryClick: () => handleCategoryClick(filterCategory.key), openCategories: openCategories, changeFilters: changeFilters, checkFiltersStatus: checkFiltersStatus }, filterCategory.key)))] })] }));
};
//# sourceMappingURL=StoreLocatorFiltersAll.js.map